module.exports = __webpack_public_path__ + "img/pageinteriors_individuos-y-familias-04accidentes.9a77dd6a.jpg";